import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { LocationOn } from "@mui/icons-material";

function Maps() {
  return (
    <Box
      id="contact_us"
      sx={{
        padding: { xs: "40px 0", md: "80px 0" },
        background: "linear-gradient(180deg, #f5f7fa 0%, #ffffff 100%)",
      }}
    >
      <Container maxWidth="xl">
        {/* Header */}
        <Box sx={{ textAlign: "center", marginBottom: "50px" }}>
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: "12px",
              marginBottom: "20px",
            }}
          >
            <LocationOn sx={{ fontSize: "36px", color: "#0277BD" }} />
          </Box>
          <Typography
            fontFamily="Montserrat"
            fontSize={{ xs: "32px", md: "48px" }}
            fontWeight={900}
            lineHeight={1.2}
            className="fade-in-up"
            sx={{
              background: "linear-gradient(135deg, #03A9F4 0%, #0277BD 50%, #025D9E 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              marginBottom: "16px",
            }}
          >
            Find Us Here
          </Typography>
          <Typography
            fontFamily="Montserrat"
            fontSize={{ xs: "14px", md: "16px" }}
            fontWeight={500}
            color="#4a5568"
          >
            Visit our headquarters in Lahore, Punjab
          </Typography>
        </Box>

        {/* Map Container */}
        <Box
          className="fade-in"
          sx={{
            borderRadius: "8px",
            overflow: "hidden",
            boxShadow: "0 20px 60px rgba(0, 0, 0, 0.15)",
            border: "4px solid white",
            transition: "all 0.4s ease",
            "&:hover": {
              boxShadow: "0 30px 80px rgba(2, 119, 189, 0.25)",
              transform: "scale(1.01)",
            }
          }}
        >
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d435519.9878498228!2d74.3343893!3d31.4829403!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39190483e58107d9%3A0xc23abe6ccc7e2462!2sLahore%2C%20Punjab!5e0!3m2!1sen!2s!4v1668615020437!5m2!1sen!2s"
            width="100%"
            height="450px"
            style={{ border: 0, display: "block" }}
            loading="lazy"
            title="RCS Express Location Map"
          />
        </Box>
      </Container>
    </Box>
  );
}

export default Maps;
